import React from 'react';
import { Award, TrendingUp, Heart, Shield } from 'lucide-react';
import profile from '../assets/optimized/about-profile.webp';

const AboutTherapist = () => {
    const highlights = [
        {
            icon: <Award size={24} />,
            title: '15+ Years Experience',
            description: 'Expert in Spa, Thai, Ayurveda & Abhyanga',
        },
        {
            icon: <Shield size={24} />,
            title: 'Certified Professional',
            description: 'Ayurveda, Panchakarma & Spa certified',
        },
        {
            icon: <Heart size={24} />,
            title: 'Client Focused',
            description: 'Personalized care for every client',
        },
        {
            icon: <TrendingUp size={24} />,
            title: 'Proven Results',
            description: 'Thousands of satisfied clients',
        },
    ];

    return (
        <section id="about" className="py-20 bg-gradient-to-b from-white to-cream">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left: Image */}
                    <div className="animate-fade-in">
                        <div className="relative">
                            <div className="absolute -inset-4 bg-gradient-to-r from-zen-gold to-coffee-900 rounded-2xl opacity-20 blur-2xl"></div>
                            <img
                                src={profile}
                                alt="Manjunatha K - Professional Massage Therapist"
                                loading="lazy"
                                decoding="async"
                                width={500}
                                height={600}
                                className="relative rounded-2xl shadow-premium w-full h-auto object-cover"
                            />
                            {/* Floating Badge */}
                            <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-white px-6 py-3 rounded-full shadow-premium">
                                <p className="text-zen-gold font-bold text-lg">15+ Years Certified</p>
                            </div>
                        </div>
                    </div>

                    {/* Right: Content */}
                    <div className="animate-fade-in">
                        <div className="inline-flex items-center bg-zen-gold/10 px-6 py-2 rounded-full mb-6">
                            <span className="text-coffee-900 font-semibold">About the Therapist</span>
                        </div>

                        <h2 className="text-4xl md:text-5xl font-display font-bold text-coffee-900 mb-6">
                            Manjunatha K
                        </h2>

                        <p className="text-lg text-coffee-700 mb-6 leading-relaxed">
                            With over 15 years of certified expertise in therapeutic massage, I specialize in
                            providing professional home service massage therapy across Bengaluru. My journey began
                            with formal training, earning a <strong className="text-zen-gold">Professional Diploma in Ayurveda & Panchakarma Therapy</strong> in 2007,
                            followed by a <strong className="text-zen-gold">Diploma in Spa & Thai Massage</strong> in 2010,
                            and official Government of Karnataka registration in 2018.
                        </p>

                        <p className="text-lg text-coffee-700 mb-6 leading-relaxed">
                            <strong className="text-zen-gold">Over 10,000+ massages performed</strong> in the last 15 years,
                            I have had the privilege of serving a diverse range of clients including <strong>paralyzed patients,
                                sports persons, aged individuals,</strong> athletes requiring deep tissue therapy, full body abhyanga and those seeking
                            stress relief through Swedish massage.
                        </p>

                        <p className="text-lg text-coffee-700 mb-8 leading-relaxed">
                            My approach combines traditional techniques with modern therapeutic practices,
                            ensuring each session is tailored to your specific needs and health conditions.
                        </p>

                        {/* Highlights Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                            {highlights.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex items-start space-x-3 bg-white p-4 rounded-xl shadow-md"
                                >
                                    <div className="bg-zen-gold/20 p-2 rounded-lg text-zen-gold flex-shrink-0">
                                        {item.icon}
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-coffee-900 mb-1">{item.title}</h4>
                                        <p className="text-sm text-coffee-700">{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CTA */}
                        <a
                            href="tel:+919901853969"
                            className="inline-block bg-zen-gold text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-coffee-900 transition-all duration-300 shadow-premium hover:shadow-glow"
                        >
                            Schedule Your Session
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutTherapist;
